import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import { getRouteByActivityType } from 'src/app/board/activity/activity-shared/activity-shared-routes';
import { RouteActivityType } from 'src/app/board/activity/activity.constants';

export const activityRentalsRoutes: MenuInterface[] = [
    {
        code: 'RentalParameters',
        route: getRouteByActivityType('ActivityParameters', RouteActivityType.Rentals)
    },
    {
        code: 'RentalParametersPermanence',
        route: getRouteByActivityType('PermanencesSettings', RouteActivityType.Rentals)
    },
    {
        code: 'RentalCatalog',
        route: getRouteByActivityType('Catalog', RouteActivityType.Rentals)
    },
    {
        code: 'RentalParametersForm',
        route: getRouteByActivityType('Forms', RouteActivityType.Rentals)
    },
    {
        code: 'RentalActions',
        route: getRouteByActivityType('GroupedActions', RouteActivityType.Rentals)
    },
    {
        code: 'RentalParametersFormFields',
        route: getRouteByActivityType('FormField', RouteActivityType.Rentals)
    },
    {
        code: 'RentalParametersChoiceSession',
        route: getRouteByActivityType('ChoiceSession', RouteActivityType.Rentals)
    },
    {
        code: 'RentalNewBooking',
        route: [
            {
                content: 'activity/rentals/new-booking',
                focus: 'empty',
            }, {primaryRoute: 'content'}
        ]
    },
    {
        code: 'RentalBookingsList',
        route: [
            {
                content: 'activity/rentals/bookings/list',
                focus: 'empty'
            },
            'content'
        ]
    },
    {
        code: 'RentalInvoicing',
        route: [
            {
                content: 'activity/rentals/invoicing/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'RentalOccupancyRate',
        route: [
            {
                content: 'activity/rentals/occupation/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'RentalPrintOccupancyRate',
        route: [
            {
                content: 'activity/rentals/prints/occupation-planning',
                focus: 'activity/rentals/prints/occupation-planning/document',
            }, 'content'
        ]
    },
    {
        code: 'RentalPrintAvailabilities',
        route: [
            {
                content: 'activity/rentals/prints/availabilities',
                focus: 'activity/rentals/prints/availabilities/document',
            }, 'content'
        ]
    },
    {
        code: 'RentalParametersModelsLetter',
        route: [
            {
                content: 'activity/rentals/settings/models/letter/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'RentalPrintSalesBalance',
        route: getRouteByActivityType('PrintSalesBalance', RouteActivityType.Rentals)
    },
    {
        code: 'RentalPrintFormOrders',
        route: getRouteByActivityType('PrintSalesBalance', RouteActivityType.Rentals)
    },
    {
        code: 'RentalInvoicesList',
        route: getRouteByActivityType('InvoicesList', RouteActivityType.Rentals)
    },
    {
        code: 'RentalParametersStatusManagement',
        route: getRouteByActivityType('StatusParameters', RouteActivityType.Rentals)
    },
    {
        code: 'RentalAllocation',
        route: getRouteByActivityType('Allocation', RouteActivityType.Rentals)
    },
    {
        code: 'RentalSuppliersFreeOrdersList',
        route: getRouteByActivityType('SuppliersFreeOrdersList', RouteActivityType.Rentals)
    },
    {
        code: 'RentalSuppliersFreeInvoicesList',
        route: getRouteByActivityType('SuppliersFreeInvoicesList', RouteActivityType.Rentals)
    },
    {
        code: 'RentalBeneficiariesFreeOrdersList',
        route: getRouteByActivityType('BeneficiariesFreeOrdersList', RouteActivityType.Rentals)
    },
    {
        code: 'RentalBeneficiariesFreeInvoicesList',
        route: getRouteByActivityType('BeneficiariesFreeInvoicesList', RouteActivityType.Rentals)
    },
    {
        code: 'RentalFreeEntriesModelsList',
        route: getRouteByActivityType('FreeEntriesModelsList', RouteActivityType.Rentals)
    },
    {
        code: 'RentalPrintDashboardInvoice',
        route: getRouteByActivityType('PrintDashboardInvoices', RouteActivityType.Rentals)
    },
    {
        code: 'RentalParametersCancellationFees',
        route: getRouteByActivityType('ActivityParametersCancellationFees', RouteActivityType.Rentals)
    }
];
